import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { MaintenanceService } from '../service/maintenance.service';

export const maintenanceInterceptor: HttpInterceptorFn = (req, next) => {
  const maintenanceService = inject(MaintenanceService);

  return next(req).pipe(
    // Check successful responses for maintenance headers
    tap((response: any) => {
      if (response?.headers) {
        const maintenanceHeader = response.headers.get('X-Maintenance-Mode');
        if (maintenanceHeader === 'true') {
          const message = response.headers.get('X-Maintenance-Message') || 
                        'The system is currently under maintenance. Please check back later.';
          const estimatedEndTime = response.headers.get('X-Maintenance-End-Time');
          maintenanceService.setMaintenanceMode(true, message, estimatedEndTime || undefined);
        }
      }
    }),
    catchError((error: HttpErrorResponse) => {
      // Check for maintenance-related status codes
      if (error.status === 503) {
        // Service Unavailable - typically indicates maintenance
        const headers = error.headers;
        const maintenanceMessage = 
          error.error?.maintenance?.message ||
          error.error?.message || 
          (headers?.get ? headers.get('X-Maintenance-Message') : null) ||
          'The system is currently under maintenance. Please check back later.';
        
        const estimatedEndTime = 
          error.error?.maintenance?.estimatedEndTime ||
          (headers?.get ? headers.get('X-Maintenance-End-Time') : null);
        
        // Set maintenance mode with all details
        maintenanceService.setMaintenanceMode(true, maintenanceMessage, estimatedEndTime || undefined);
      } else if (error.status === 502) {
        // Bad Gateway - backend service might be down
        maintenanceService.enableMaintenanceMode(
          'The service is temporarily unavailable. Please try again later.'
        );
      } else if (error.status === 0) {
        // Network error - could indicate backend is down
        // Only set maintenance mode if we've had multiple failures
        // For now, let the maintenance service handle this through periodic checks
        // This prevents false positives from temporary network issues
      }

      // Check response headers for maintenance mode indicator
      if (error.headers) {
        const maintenanceHeader = error.headers.get('X-Maintenance-Mode');
        if (maintenanceHeader === 'true') {
          const message = error.headers.get('X-Maintenance-Message') || 
                        'The system is currently under maintenance. Please check back later.';
          const estimatedEndTime = error.headers.get('X-Maintenance-End-Time');
          maintenanceService.setMaintenanceMode(true, message, estimatedEndTime || undefined);
        }
      }

      return throwError(() => error);
    })
  );
};

